
export const dk_blue = '#00348D'
export const dk_yellow = '#FDC617'
export const dk_gray = '#6E7177'
export const dk_light_gray = '#cbc9c9'

export const navTitleFont = 'Panton-Lightcaps'
export const textFont = 'Roboto-Light'

export const defaultText = {
    fontFamily: textFont
}

export const defaultTitle = {
    fontFamily: navTitleFont,
}

